import { atom, useAtom } from "jotai";

import { RFQRequestState } from "#/services/kyan/kyan.types";

export const selectedRfqRequestAtom = atom<RFQRequestState>();

export const useSelectedRfqRequest = () => {
  const [selectedRfqRequest, setSelectedRfqRequest] = useAtom(
    selectedRfqRequestAtom,
  );

  return {
    selectedRfqRequest,
    setSelectedRfqRequest,
  };
};
